import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./LandingPage.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MemberLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/access/email-login`, { email });
      navigate("/sundaybuilder");
    } catch (err) {
      setError(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="li-page sb-shell"
      style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <div className="li-wrap" style={{ maxWidth: 520 }}>
        <div className="li-eyebrow">Member Re-Entry</div>
        <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 52, lineHeight: 1.05, margin: "0 0 14px", color: "var(--cream)" }}>
          Welcome back.
        </h1>
        <p style={{ color: "var(--muted)", fontSize: 18, lineHeight: 1.8, marginBottom: 30 }}>
          Enter the email address you used to purchase. We'll confirm your membership with Stripe and
          take you straight to SundayBuilder™.
        </p>

        <form className="sb-form" onSubmit={submit}>
          <label className="sb-field">
            <span>Email address</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@church.org"
              data-testid="login-email-input"
            />
          </label>

          {error && (
            <div data-testid="login-error" style={{ color: "#e7b75f", fontSize: 15, lineHeight: 1.6 }}>
              {error}
            </div>
          )}

          <button className="li-button" type="submit" disabled={loading} data-testid="login-submit">
            {loading ? "Checking…" : "Enter SundayBuilder™"}
          </button>
        </form>

        <p style={{ marginTop: 28, fontFamily: "'Jost', sans-serif", fontSize: 13, letterSpacing: ".05em", color: "var(--muted)" }}>
          Not a member yet?{" "}
          <a href="/#li-pricing" style={{ color: "var(--gold)", textDecoration: "none" }} data-testid="login-to-pricing">
            View plans
          </a>
        </p>
      </div>
    </div>
  );
}
